<template>
    <div class="gray-panel" :class="className">
        <slot />
    </div>
</template>

<script lang="ts">
export default {
    props: {
        className: {
            type: String
        }
    }
};
</script>

<style lang="css">
.gray-panel {
    padding: 24px 16px;

    border-radius: 8px;
    background-color: var(--wpp-grey-color-100);

    overflow: hidden;
}
</style>
